module.exports = __webpack_public_path__ + "img/fas-redo-alt.525beace.svg";